import React from "react";
import * as FaIcons from "react-icons/fa";

import PreferredPronouns from "../../../data/PreferredPronouns";

const R22StudentPreferences =( {

    formData,
    onFormDataChange,
    validationCheck,
    getAge,
  }) => {
    const {
        firstName,
      registerForIntercession,
      studentName,
      preferredpronouns,
      otherpreferredpronouns,
    } = formData;
  
  
  
   
  
    // const handleChange = (e) => {
    //   const value = e.target.value;
    //   e.target.value =
    //     value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
    //   onFormDataChange(e);
    // };
  
    // const [county, setcounty] = useState("United States of America");
    // const handleChange2 = (e) => {
    //   setcounty(e.target.value);
    //   onFormDataChange(e);
    // };
  
    // const validatezipCode = (e) => {
    //   const re = /^\d{5}$/;
    //   return re.test(String(e).toLowerCase());
    // };
  
    // const handleChange1 = (e) => {
    //   const regex = /^[0-9\b]+$/;
    //   if (e.target.value === "" || regex.test(e.target.value)) {
    //     var aVal = e.target.value;
    //     if (aVal.length < 5) {
    //       e.target.value = aVal;
    //     }
    //   }
    //   onFormDataChange(e);
    // };
  
    const studentPreferenceFilled = "";
    // studentName !== "" &&    preferredpronouns !== "" &&
    // otherpreferredpronouns !== "";
  
    // useEffect(() => {
    //   const handleBeforeUnload = (event) => {
    //     const message = "Are you sure you want to leave?";
    //     event.returnValue = message;
    //   };
  
    //   window.addEventListener("beforeunload", handleBeforeUnload);
  
    //   return () => {
    //     window.removeEventListener("beforeunload", handleBeforeUnload);
    //   };
    // }, []);
  
    return (
    //   <>
    //     {/* <div className="sub-form">
    //       <h2 className="">
    //         Student Preference <span>(2/11)</span>
    //         <hr />
    //       </h2>
    //       <div className="item">
    //         <div className="asterisk-group">
    //           <h3>
    //             What is {firstName === "" ? "the Student" : firstName}'s Preferred
    //             Name?
    //           </h3>
    //         </div>
    //         <input
    //           type="text"
    //           name="studentName"
    //           maxLength="50"
    //           onChange={(e) => onFormDataChange(e)}
    //           value={studentName}
    //           style={{
    //             border:
    //               validationCheck && !(studentName !== "")
    //                 ? "2px solid #d8302f"
    //                 : "",
    //           }}
    //         />
    //       </div>
  
    //       <div className="item">
    //         <div className="asterisk-group">
    //           <h3>
    //             What is {firstName === "" ? "The Student's" : firstName}'s
    //             Preferred Pronouns?
    //           </h3>
    //         </div>
    //         <select
    //           name="preferredpronouns"
    //           value={preferredpronouns}
    //           onChange={(e) => onFormDataChange(e)}
    //           style={{
    //             border:
    //               validationCheck && !(preferredpronouns !== "") ? "2px solid #d8302f" : "",
    //           }}
    //         >
    //           <option value="">Please Select </option>
    //           {PreferredPronouns.map((item) => {
    //             return <option value={item}>{item}</option>;
    //           })}
    //         </select>
    //       </div>
    //    </div> */}
    //   </>
    <>
    {/* Student Information */}
    <div className="sub-form">
      <h3> Student Preference </h3>
      <div className="sum-item">
        <div className="asterisk-group">
          <h4> What is {firstName === "" ? "the Student" : firstName}'s Preferred
                 Name?</h4>
          {/* <FaIcons.FaAsterisk className="asterisk-icon" /> */}
        </div>
        <input
          type="text"
          name="studentName"
          onChange={(e) => {
            onFormDataChange(e);
          }}
          value={studentName}
          style={{
            border:
              validationCheck && !(studentName !== "")
                ? "2px solid #d8302f"
                : "",
          }}
        />
      </div>
      <div className="sum-item">
        <div className="asterisk-group">
          <h4>
          What is {firstName === "" ? "The Student's" : firstName}'s
              Preferred Pronouns?
          </h4>
        </div>
        <select
              name="preferredpronouns"
              value={preferredpronouns}
              onChange={(e) => onFormDataChange(e)}
              style={{
                border:
                  validationCheck && !(preferredpronouns !== "") ? "2px solid #d8302f" : "",
              }}
            >
              <option value="">Please Select </option>
              {PreferredPronouns.map((item) => {
                return <option value={item}>{item}</option>;
              })}
            </select>
      </div>

    
      
     

     
    </div>
  </>
    );
  };
  
  export default R22StudentPreferences;